module.exports = __webpack_public_path__ + "static/media/ACOMODO-new.69df9caa.png";